// extracted by mini-css-extract-plugin
export default {"otherPhone":"styles_otherPhone__YLe0W"};